<div class="multiselect-with-select-field">
    <div class="row multiselect-with-select-field-wrapper m-b-xs" (dblclick)="editModeOn()">
        <div *ngIf="!editOnly" class="dv-value col-sm-12" [class.hidden]="isEditMode" style="min-height: 34px;border-bottom: 1px solid #e5e6e7;">
            <span *ngFor="let group of value.limitedPassTypes" class="group-label m-b-xs">{{group.itemName}}</span>

            <span *ngIf="!value.limitedPassTypes || !value.limitedPassTypes.length" class="m-b-xs">-</span>
        </div>
        <div *ngIf="!editOnly" class="dv-value col-sm-12 input-select-value" [class.hidden]="isEditMode">
            <span class="m-b-xs">
                <span *ngIf="value.limitCount && value.limitSequenceType">
                    Limit {{value.limitCount}}
                    <span *ngIf="value.limitSequenceType =='day'">Per Day</span>
                    <span *ngIf="value.limitSequenceType =='week'">Per Week</span>
                    <span *ngIf="value.limitSequenceType =='month'">Per Month</span>
                    <span *ngIf="value.limitSequenceType =='year'">Per Year</span>
                </span>
            </span>

            <span *ngIf="!value.limitCount || !value.limitSequenceType" class="m-b-xs">-</span>
        </div>


        <div class="dv-value col-sm-12 edit-mode-multiselect-wrapper" [class.hidden]="!isEditMode">
            <div class="col-sm-12 multiselect-container"
                 [ngStyle]="{'margin-top' : value.limitedPassTypes && value.limitedPassTypes.length ? '' : '5px'}">
                <angular2-multiselect
                    [data]="data"
                    [(ngModel)]="value.limitedPassTypes"
                    [settings]="multiselectSettings">
                </angular2-multiselect>
            </div>
        </div>
        <div class="input-select-field-row" [class.hidden]="!isEditMode">
            <span>Limit</span>
            <input class="form-control"
                   [(ngModel)]="value.limitCount"
                   maxlength="255"
                   type="text"
                   pattern="[0-9]+"
                   (keypress)="validateValue($event)">

            <select [(ngModel)]="value.limitSequenceType" class="form-control">
                <option value="" hidden></option>
                <option *ngFor="let type of selectValues" [value]="type.name">
                    {{type.displayName}}
                </option>
            </select>
        </div>
    </div>
    <div *ngIf="!editOnly" class="m-t-xs m-r-xs apart-btns pull-right" style="padding: 0;">
        <button *ngIf="isEditMode" type="button" class="apply" (click)="apply()">
            <i class="fa fa-check"></i>
        </button>
        <button *ngIf="isEditMode" type="button" class="reset" (click)="cancel()">
            <i class="fa fa-times"></i>
        </button>
        <button *ngIf="isEditMode" type="button" class="reset" (click)="remove()">
            <i class="fa fa-trash without-hover"></i>
        </button>
        <i *ngIf="!isEditMode && !noEdit" class="fa fa-pencil pull-right" (click)="editModeOn()"
           data-toggle="tooltip" data-placement="top" title="Edit"></i>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/fields/multiselect-with-select-field/multiselect-with-select-field.component.html